import React from 'react';
import { BrowserRouter as Router, Route, Routes, To } from 'react-router-dom';

import { pageKeywords, pagePaths } from '../constants/Page';
import { Error403, Error404, Error500 } from '../containers/pages/Error';
import OutsourceMemberReport from '../containers/pages/Root';
import Succeeded from '../containers/pages/Succeeded';
import WorkReport from '../containers/pages/work-report/WorkReport';
import WorkDocReport from '../containers/pages/WorkDocReport';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LocationState = { from: To; [x: string]: any };

const AppRouter: React.FunctionComponent = () => {
  // const auth = useAuthContext();

  return (
    <Router basename="/outsourcer/">
      <Routes>
        <Route
          path={pageKeywords.main.ROOT}
          element={<OutsourceMemberReport />}
        >
          <Route path={pageKeywords.main.WORK_CONTENT}>
            <Route
              path={pageKeywords.mode.EDIT}
              element={<WorkReport mode="edit" />}
            />
            <Route
              path={pageKeywords.mode.VIEW}
              element={<WorkReport mode="view" />}
            />
          </Route>
          <Route path={pageKeywords.main.WORK_REPORT}>
            <Route
              path={pageKeywords.mode.EDIT}
              element={<WorkDocReport mode="edit" />}
            />
            <Route
              path={pageKeywords.mode.VIEW}
              element={<WorkDocReport mode="view" />}
            />
          </Route>
          <Route path="error403" element={<Error403 />} />
          <Route path="error500" element={<Error500 />} />
          <Route path="*" element={<Error404 />} />
        </Route>
        <Route path={pageKeywords.main.SUCCEEDED} element={<Succeeded />} />
      </Routes>
    </Router>
  );
};
export default AppRouter;
